<template>
  <div class="view-step">
    <div v-if="isBom" class="step-item is-bom">
      <div class="step-top">0/{{ tableDataList.length }}</div>
      <div class="step-circle">
        <span class="step-icon iconfont icon-right"></span>
      </div>
      <div class="step-line"></div>
      <div class="step-bottom">配件({{ bomLen }}件)</div>
    </div>
    <div v-else class="step-item">
      <div class="step-top">{{ data.table_data_1[0].name }}</div>
      <div class="step-circle">
        <span class="step-icon iconfont icon-right"></span>
      </div>
      <div class="step-line"></div>
      <div class="step-bottom">原材料</div>
    </div>
    <div
      :class="{ 'step-item': true, 'is-bom': isBom }"
      v-for="(item, index) in tableDataList"
      :key="index"
    >
      <div class="step-top">{{ item.name }}</div>
      <div class="step-circle"></div>
      <div class="step-line"></div>
      <div class="step-bottom">{{ item.item_type }}{{ item.item_index }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    effectCount() {
      let result = 0
      let effectList = this.data.tableBomData.filter((item) => {
        return item.name
      })
      result = effectList.length
      return result
    },
    isBom() {
      let result = !!this.data.tableBomData.length
      return result
    },
    bomLen() {
      let result = this.data.tableBomData.length
      return result
    },
    tableDataList() {
      let result = []
      this.data.table_data_3.forEach((item, index) => {
        let obj = this.$util.deepCopy(item)
        obj.item_type = '工艺'
        obj.item_index = index + 1
        result.push(obj)
      })
      this.data.table_data_4.forEach((item, index) => {
        let obj = this.$util.deepCopy(item)
        obj.item_type = '费用'
        obj.item_index = index + 1
        result.push(obj)
      })
      return result
    }
  }
}
</script>

<style lang="less" scoped>
.view-step {
  display: flex;
  margin-left: 40px;
  .step-item {
    position: relative;
    min-width: 50px;
    text-align: center;
    & ~ .step-item {
      padding-left: 20px;
    }
    &:first-child {
      .step-line {
        left: 40%;
      }
    }
    &:last-child {
      .step-line {
        right: 40%;
      }
    }
    &.is-bom {
      .step-top {
        background: @colorOrange;
      }
      .step-circle {
        background: @colorOrange;
        border-color: #ffc9b7;
      }
      .step-line {
        border-color: @colorOrange;
      }
      .step-bottom {
        color: @colorOrange;
      }
    }
    .step-top {
      padding: 0 10px;
      line-height: 20px;
      color: @colorWhite;
      background: @colorBlue;
      border-radius: 10px;
    }
    .step-circle {
      position: relative;
      margin: 3px auto;
      width: 10px;
      height: 10px;
      text-align: center;
      line-height: 10px;
      background: @colorBlue;
      border: 2px solid #bbdcff;
      border-radius: 7px;
      z-index: 1;
      .step-icon {
        font-size: 8px;
        color: @colorWhite;
      }
    }
    .step-line {
      border-top: 1px dashed @colorBlue;
      position: absolute;
      top: 30px;
      left: 0;
      right: 0;
    }
    .step-bottom {
      line-height: 20px;
      color: @colorBlue;
    }
  }
}
</style>
